<template>
  <div id="rightCenter">
    <div class="bg-color-black">
      <div class="d-flex title-box">
        <div class="d-flex">
          <span class="fs-xl text_title mx-2 commonTitle">织物全生命周期数据分析</span>
          <div class="decoration2">
            <dv-decoration-2 :reverse="true" />
          </div>
        </div>
      </div>
      <div class="body-box">
        <rightCenterChart :data="result" />
      </div>
    </div>
  </div>
</template>

<script>
import rightCenterChart from "@/components/echart/rightCenter";
import * as api from "@/api/index";

export default {
  components: {
    rightCenterChart,
  },
  data() {
    return {
      params: {
        customerId: "",
      },
      result: [],
      intervalId: null,
    };
  },
  mounted() {
    this.params.customerId = this.$route.query.customerId;
    this.getData();

    this.intervalId = setInterval(() => {
      this.getData();
    }, 30 * 60 * 1000);
  },
  beforeDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },
  methods: {
    async getData() {
      const res = await api.getBigSkuWashCategory(this.params);
      if (res.ResultCode !== 0) return;
      this.result = res.Result || [];
    },
  },
};
</script>

<style lang="scss" scoped>
#rightCenter {
  width: 100%;
  border-radius: 0.3vw;
  height: 100%;
  .bg-color-black {
    height: 100%;
    border-radius: 0.5vw;
    .title-box {
      height: 18%;
      padding: 0 1vw;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
    }
    .body-box {
      height: 82%;
    }
  }

  .decoration2 {
    position: absolute;
    right: 0.1vw;
  }

  .chart-box {
    margin-top: 1vh;
    width: 8vw;
    height: 8vw;

    .active-ring-name {
      padding-top: 0.5vh;
    }
  }
}
</style>

